import React, { FC } from 'react';
import * as ST from './styled';

interface IPopupResponseProps {
    isOpen: boolean,
    onClose: () => void,
    message?: string,
}

const PopupResponse: FC<IPopupResponseProps> = ({ message, isOpen, onClose }) => {
    return (
        <ST.ResponsePopup isOpen={isOpen} onClose={onClose}>
            <ST.Text>{message}</ST.Text>
        </ST.ResponsePopup>
    );
};

export default PopupResponse;
